import { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { IconeDoTipoPeriodo } from '@/modules/business/periodo/Icones';
import { getRegrasExplicacaoPorTipo } from '@/modules/business/periodo/periodo-regras.utils';
import { TipoPeriodoDescanso } from './enums/tipo-periodo-descanso.enum';
import { TipoPeriodoDescansoList } from '@/shared/constants/enumlist';

type Props = {
  tipo: TipoPeriodoDescanso;
};

export default function PeriodoRegrasCollapse({ tipo }: Props) {
  const [aberto, setAberto] = useState(false);
  const regras = getRegrasExplicacaoPorTipo(tipo);
  const nomeTipo =
    TipoPeriodoDescansoList.find((item) => item.value === tipo)?.name ?? 'Evento';

  return (
    <div className="card-footer small text-muted p-0">
      <button
        type="button"
        className="btn btn-link btn-sm text-muted text-decoration-none w-100 d-flex justify-content-between align-items-center px-3 py-2"
        onClick={() => setAberto(!aberto)}
        aria-expanded={aberto}
        aria-controls="collapse-regras-periodo"
      >
        <span className="d-flex align-items-center gap-1">
          {IconeDoTipoPeriodo(tipo)}
          Regras de validação — {nomeTipo}
        </span>
        <span aria-hidden="true">{aberto ? '▼' : '▶'}</span>
      </button>
      <Collapse in={aberto}>
        <div id="collapse-regras-periodo" className="px-3 pb-3">
          <ul className="mb-0 ps-3">
            {regras.map((regra, index) => (
              <li key={index}>{regra}</li>
            ))}
          </ul>
          <p className="mb-0 mt-2 fst-italic">
            As validações acima dependem das regras ativas em Regras de Validação.
          </p>
        </div>
      </Collapse>
    </div>
  );
}
